import React from "react";
import { Button, Typography } from "@mui/material";

const WebGlDoneButton = ({ onClick }) => {
    return (
        <Button
            onClick={onClick}
            variant="contained"
            size="large"
            sx={{
                borderRadius: 3,
                px: 4,
                whiteSpace: "nowrap",
                backgroundColor: "primary.main",
                color: "white",
                "&:hover": { backgroundColor: "primary.dark" },
            }}
        >
            <Typography
                sx={{
                    fontFamily: "Montserrat, sans-serif",
                    fontWeight: 700,
                    fontSize: "14.4px",
                    lineHeight: "35.03px",
                    letterSpacing: 0,
                    textAlign: "center",
                    verticalAlign: "middle",
                    textTransform: "uppercase",
                    whiteSpace: "nowrap"
                }}>
                PRONTO, SEGUI TODOS OS PASSOS
            </Typography>
        </Button>
    );
};

export default WebGlDoneButton;
